import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { IcChevron24Icon } from '@gem/icons';
import { IconView, IconViewSizes, RoundedListItem } from '@gem/ui-kit';

import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { LoginSupportInfo } from '../../../components/LoginSupportInfo/LoginSupportInfo';
import {
  ILoginWithAuthorizationConfigProps,
  useLoginWithAuthorizationConfigPresenter,
} from './LoginWithAuthorizationConfig.presenter';
import styles from './LoginWithAuthorizationConfig.styles.m.css';

export const LoginWithAuthorizationConfig: FC<ILoginWithAuthorizationConfigProps> = observer(
  (props) => {
    const { loginPresenter } = props;
    const { t } = useTranslation();
    const presenter = useLoginWithAuthorizationConfigPresenter(props);

    if (!presenter.authorizationConfig) {
      return null;
    }

    return (
      <UnauthorizedLayoutTemplate
        onBack={loginPresenter.onBackHandler || undefined}
        title={t('auth_sign_in')}
        subtitle={t('auth_sign_in_subtitle')}
        info={<LoginSupportInfo />}
        message={loginPresenter.errorMessage}
        className={styles.container}
      >
        {presenter.listItems.map((item) => {
          return (
            <Fragment key={item.key}>
              <RoundedListItem
                className={classNames(styles.item, styles[`item-${item.key}`])}
                isDisabled={presenter.isLoading}
                suffix={
                  <IconView
                    Icon={IcChevron24Icon}
                    theme="inherit"
                    className={styles.chevronIcon}
                  />
                }
                prefix={
                  <span className={styles.itemIcon}>
                    <IconView
                      theme="inherit"
                      Icon={item.Icon}
                      size={IconViewSizes.Medium}
                    />
                  </span>
                }
                title={item.title}
                subtitle={item.subtitle}
                onClick={item.onClick}
              />
            </Fragment>
          );
        })}
      </UnauthorizedLayoutTemplate>
    );
  }
);
